export default __webpack_public_path__ + "static/media/loginRegisterBackground.fbd0105b.jpg";